import { Controller } from "@hotwired/stimulus"

// Reports the browser's IANA zone so the server can anchor day-granular
// windows to the viewer's day (#3325). Written on every connect: it heals a
// zone change (travel) and the server validates the value anyway.
export default class extends Controller {
  connect() {
    try {
      const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (zone) {
        document.cookie = `browser_tz=${encodeURIComponent(zone)}; path=/; max-age=31536000; samesite=lax`
      }
    } catch {
      // Intl unavailable: the server default applies.
    }
  }
}
